import type { Theme } from "../..";
import type { UseThemeFontProps } from "./types";

import { useThemePrimitives } from "./useThemePrimitives";

/**
 * `useThemeFont()`
 *
 * This hook can be used to get font related primitives from the given theme and subtheme.
 * If theme or subtheme are not specified, it will return font primitives for all themes and subthemes.
 */
function useThemeFont(themeFile: Theme.GriddoTheme, props?: UseThemeFontProps) {
	return useThemePrimitives(themeFile, {
		...props,
		primitive: ["fontFamily", "fontSize"],
	});
}

export { useThemeFont };
